import { createFileRoute } from '@tanstack/react-router'
import IcpDetailPage from '@/components/business-value/IcpDetailPage'
import { dataCenters } from '@/data/business-value'

export const Route = createFileRoute('/_app/business-value/data-centers')({
  component: DataCentersPage,
})

function DataCentersPage() {
  return <IcpDetailPage icp={dataCenters} />
}
